export enum NoAccessReasons {
  MISSING_PERMISSIONS = 'Missing Permissions',
  LOGIN_ERROR = 'Something went wrong'
}
